export default __webpack_public_path__ + "static/media/cn.8d059c2f.svg";